import React, { useMemo } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";


export default function FiltroLeggiDDL({ documenti, value, onChange }) {
    const selection = useMemo(
        () => documenti.filter((d) => value?.includes(d.titolo)),
        [value, documenti]
    );

    const handleSelectionChange = (e) => {
        onChange(e.value.map((d) => d.titolo));
    };

    const isRowSelectable = (e) => e.data?.riferimento != null;

    const titoloBody = (rowData) => {
        const disabilitata = rowData.riferimento == null;
        return (
            <div style={disabilitata ? { opacity: 0.4 } : undefined}>
                <div>
                    {rowData.titolo}
                    {rowData.ddl && <span style={{ fontSize: "0.95rem"}}> (DdL n. {rowData.ddl})</span>}
                </div>
                <div style={{ fontSize: "0.9rem", fontStyle: "italic", color: "#8b3a3a", marginTop: 2 }}>
                    {rowData.riferimento}
                </div>
            </div>
        );
    };

    return (
        <div>
            <DataTable value={documenti} dataKey="titolo" size="small" stripedRows className="w-full"
                scrollable scrollHeight="45vh" selectionMode="checkbox" selection={selection} showSelectAll={false}
                isDataSelectable={isRowSelectable}
                onSelectionChange={handleSelectionChange}>
                <Column selectionMode="multiple" headerStyle={{ width: "1rem" }} />
                <Column header="Titolo" body={titoloBody} />
            </DataTable>
        </div>
    );
}